import React, { useMemo } from "react";
import { Col, Collapse, Divider, Form, Row, Typography } from "antd";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import {
  ankleOptions,
  cervicalOptions,
  elbowOptions,
  hipOptions,
  kneeOptions,
  lumbarOptions,
  positiveNegativeOptions,
  sacroiliacOptions,
  shoulderOptions,
  specialTestCategories,
  thoracicOptions,
  tnjOptions,
  wristAndHandOptions,
} from "../Orthoform/orthoOptions";

const sideOptions = ["left", "right"];

const createOptionsMap = (options) => {
  return options.reduce((acc, curr) => {
    acc[curr.key] = curr.options;
    return acc;
  }, {});
};

const SpecialTestsForm = ({ onValuesChange, formData }) => {
  const [form] = Form.useForm();

  const optionsMap = useMemo(
    () =>
      createOptionsMap([
        { key: 1, options: shoulderOptions },
        { key: 2, options: elbowOptions },
        { key: 3, options: wristAndHandOptions },
        { key: 4, options: hipOptions },
        { key: 5, options: kneeOptions },
        { key: 6, options: ankleOptions },
        { key: 7, options: cervicalOptions },
        { key: 8, options: thoracicOptions },
        { key: 9, options: lumbarOptions },
        { key: 10, options: sacroiliacOptions },
        { key: 11, options: tnjOptions },
      ]),
    []
  );

  const RadioGroupSection = useMemo(
    () =>
      ({ categoryKey, categoryValue, side }) => {
        const options = optionsMap[categoryKey] || [];

        return options?.map((subOption) => (
          <DeselectableRadioGroup
            key={[categoryValue, side, subOption?.value]}
            name={[categoryValue, side, subOption?.value]}
            label={subOption?.label}
            options={positiveNegativeOptions}
            form={form}
          />
        ));
      },
    [form, optionsMap]
  );

  const items = useMemo(
    () =>
      specialTestCategories.map((category) => ({
        key: category?.key,
        label: category?.label,
        children: (
          <Row gutter={10}>
            {sideOptions?.map((side) => (
              <Col
                key={side}
                xs={24}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                // xl={side === "right" ? { offset: 4, span: 8 } : { span: 12 }}
              >
                <Typography.Text>
                  {side.charAt(0).toUpperCase() + side.slice(1)}
                </Typography.Text>
                <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                <RadioGroupSection
                  categoryKey={category?.key}
                  categoryValue={category?.value}
                  side={side}
                />
              </Col>
            ))}
          </Row>
        ),
      })),
    [RadioGroupSection]
  );

  const defaultOpenKeys = useMemo(
    () => specialTestCategories?.map((category) => category?.key),
    []
  );

  return (
    <Form
      id="special-test-form"
      form={form}
      onValuesChange={(cur, all) => onValuesChange("special_tests", all)}
      layout="vertical"
      className="ip-forms"
      initialValues={formData?.special_tests}
    >
      <Collapse
        defaultActiveKey={defaultOpenKeys}
        items={items}
        expandIconPosition="right"
      />
    </Form>
  );
};

export default SpecialTestsForm;
